import { ChatBotProvider } from '@/contexts/ChatBotContext'
import { CookieConsentProvider } from '@/contexts/CookieConsentContext'
import { LanguageRouter } from '@/components/LanguageRouter'

export default function App() {
  return (
    <CookieConsentProvider>
      <ChatBotProvider>
        <LanguageRouter />
      </ChatBotProvider>
    </CookieConsentProvider>
  )
}
